import type { AlertColor } from "@mui/material";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const initialState: {
  snackbarOpen: boolean;
  snackbarAutoCloseDuration: number;
  alertSeverity: AlertColor;
  alertMessage: string;
} = {
  snackbarOpen: false,
  snackbarAutoCloseDuration: 5000,
  alertSeverity: "info",
  alertMessage: "Alert Message",
};

export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    showErrorMessage: (state, action: PayloadAction<string>) => {
      state.alertMessage = action.payload;
      state.snackbarOpen = true;
      state.alertSeverity = "error";
    },
    showSuccessMessage: (state, action: PayloadAction<string>) => {
      state.alertMessage = action.payload;
      state.snackbarOpen = true;
      state.alertSeverity = "success";
    },
    showInfoMessage: (state, action: PayloadAction<string>) => {
      state.alertMessage = action.payload;
      state.snackbarOpen = true;
      state.alertSeverity = "info";
    },
    showWarningMessage: (state, action: PayloadAction<string>) => {
      state.alertMessage = action.payload;
      state.snackbarOpen = true;
      state.alertSeverity = "warning";
    },
    closeSnackbar: (state) => {
      state.snackbarOpen = false;
    },
  },
});

export const {
  showErrorMessage,
  showSuccessMessage,
  showInfoMessage,
  showWarningMessage,
  closeSnackbar,
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
